/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { DEFAULT_FILTERS } from '@zcode-ui/filters'
import { PROP_NAMES } from '@zcode/mixpanel'
import type { State } from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import deepequal from 'fast-deep-equal'
import { getCurrentSearchMatching } from '../../../inspectors/index'
import { selectFilters } from '../../filters/selectors/index'
import { getFilterPropObject } from './getFilterPropObject'

export const getFilterProps = (
  state: State
): MaybeEmpty<ReturnType<typeof getFilterPropObject> & { [PROP_NAMES.LISTABLE_COUNT]: number }> => {
  const filters = selectFilters(state)

  if (deepequal(filters, DEFAULT_FILTERS)) {
    return {}
  }

  const filterProps = getFilterPropObject(state)
  const matchingCount = getCurrentSearchMatching(state)

  return {
    ...filterProps,
    [PROP_NAMES.LISTABLE_COUNT]: matchingCount,
  }
}
